import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { IFiltroRelatorioSaldoArmazem } from '../armazem/filter/filtro-relatorio-saldo-armazem';
import { SaldoArmazemLista } from '../armazem/interface/saldo-armazem';
import { IFiltroRelatorioTransferenciasExpedicao } from '../armazem/filter/filtro-relatorio-transferencias-expedicao';
import { TransferenciasExpedicaoLista } from '../armazem/interface/transferencias-expedicao';


@Injectable({
  providedIn: 'root'
})
export class EstoqueService {

  constructor(
    private http: HttpClient,
    private utilService: UtilService
  ) { }

  url = `${environment.urlApiProtheus}/wsrestoque`;

  getListaRelatorioSaldoArmazem(filtro: IFiltroRelatorioSaldoArmazem): Observable<SaldoArmazemLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<SaldoArmazemLista>(`${this.url}/relatorio/armazem`, httpOptions);
  }

  getListaRelatorioTransferenciasExpedicao(filtro: IFiltroRelatorioTransferenciasExpedicao): Observable<TransferenciasExpedicaoLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<TransferenciasExpedicaoLista>(`${this.url}/relatorio/transferencia-expedicao`, httpOptions);
  }

}
